"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUnderDevelopment = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Construction = _interopRequireDefault(require("@mui/icons-material/Construction"));
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _react2 = require("@emotion/react");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _reactRouterDom = require("react-router-dom");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const bounce = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n"])));
const shake = (0, _react2.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  25% { transform: rotate(-5deg); }\n  75% { transform: rotate(5deg); }\n  100% { transform: rotate(0deg); }\n"])));
const DmsUnderDevelopment = () => {
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    textAlign: "center",
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: _Construction.default,
    sx: {
      fontSize: 80,
      mb: 2,
      color: 'warning.main',
      animation: "".concat(shake, " 1s ease-in-out infinite")
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h1",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("UnderDevelopment").d("Under Development")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("ThisPageIsUnderDevelopment").d("This page is under development")), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_Home.default, null),
    component: _reactRouterDom.Link,
    to: "/"
  }, _reactIntlUniversal.default.get("GoHome").d("Go Home")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    sx: {
      display: 'flex',
      justifyContent: 'center',
      mt: 4,
      animation: "".concat(bounce, " 2s infinite")
    }
  }, /*#__PURE__*/_react.default.createElement(_Construction.default, {
    sx: {
      fontSize: 40,
      mx: 1
    }
  }), /*#__PURE__*/_react.default.createElement(_Construction.default, {
    sx: {
      fontSize: 40,
      mx: 1
    }
  }), /*#__PURE__*/_react.default.createElement(_Construction.default, {
    sx: {
      fontSize: 40,
      mx: 1
    }
  })));
};
exports.DmsUnderDevelopment = DmsUnderDevelopment;